import { render, staticRenderFns } from "./data-objects-tab.vue?vue&type=template&id=1e50c7e8"
import script from "./data-objects-tab.vue?vue&type=script&lang=js"
export * from "./data-objects-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports